export default {
  schema: {
    title: 'Files Screen',
    properties: {
      file: {
        title: 'Upload File',
        format: 'uri',
        type: 'string'
      },
      files: {
        title: 'Files',
        items: {
          properties: {
            id: {
              title: 'id',
              type: 'string'
            },
            sample: {
              title: 'Sample',
              type: 'string'
            },
            file: {
              title: 'Upload File',
              format: 'uri',
              type: 'string'
            }
          },
          additionalProperties: false,
          type: 'object'
        },
        minItems: 1,
        uniqueItems: false,
        type: 'array'
      }
    },
    additionalProperties: false,
    type: 'object'
  },
  uiSchema: {
    'ui:title': {
      text: 'Files Screen',
      escape: false
    },
    'dm:layout': [{
      id: 'file',
      type: 'field'
    }, {
      id: 'files',
      type: 'array'
    }],
    file: {
      'ui:title': {
        text: 'Upload File',
        escape: false
      },
      'ui:widget': 'file'
    },
    files: {
      items: {
        'dm:layout': [{
          id: 'sample',
          type: 'field'
        }, {
          id: 'file',
          type: 'field'
        }],
        sample: {
          'ui:widget': 'text'
        },
        file: {
          'ui:title': {
            text: 'Upload File',
            escape: false
          },
          'ui:widget': 'file'
        }
      },
      'ui:title': {
        text: '<b>Files</b>',
        escape: false
      },
      'ui:options': {
        itemName: 'File'
      }
    }
  },
  formData: {
    file: 'https://sprint.digitalmeasures.com/static-assets/images/client/dmlogo.png',
    files: [{
      id: '161816379394',
      file: 'https://sprint.digitalmeasures.com/static-assets/images/client/dmlogo.png'
    }, {
      id: '161816379395',
      file: 'https://alpha.digitalmeasures.com/static-assets/images/client/dmlogo.png'
    }, {
      id: '161816379396'
    }]
  },
  fileMetadata: [{
    location: 'https://sprint.digitalmeasures.com/static-assets/images/client/dmlogo.png',
    size: 14116,
    mimeType: 'image/png',
    name: 'dmlogo.png'
  }, {
    location: 'https://alpha.digitalmeasures.com/static-assets/images/client/dmlogo.png',
    size: 14116,
    mimeType: 'image/png',
    name: 'dmlogo.png'
  }]
};